import { createContext, useContext, useEffect, useState, ReactNode } from 'react'

interface ThemeContextType {
    isDarkMode: boolean;
    toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
    children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
    const savedMode = localStorage.getItem('themeColor');
    const [isDarkMode, setIsDarkMode] = useState(savedMode === 'dark' ? true : false);

    const toggleTheme = () => {
        setIsDarkMode(prev => !prev);
    }

    useEffect(() => {
        localStorage.setItem('themeColor', isDarkMode ? 'dark' : 'light');
    }, [isDarkMode]);

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export default function useThemeMode() {
    try {
        const context = useContext(ThemeContext);
        if (context === undefined) {
            throw new Error('useThemeMode must be used within a ThemeProvider');
        }
        return context;
    } catch (error) {
        console.error('Error in useThemeMode:', error);
        return { isDarkMode: false, toggleTheme: () => { } };
    }
}